import { formatDateIso } from '../../dateTime';

export type ProgramLike = {
  startDate: number;
  endDate: number;
};

export function getProgramAiringDateIso<T extends ProgramLike>(program: T) {
  return formatDateIso(new Date(program.startDate));
}
